import CryptoJS from 'crypto-js';

const SECRET_KEY = import.meta.env.VITE_SECRET_KEY;

export function storeEncryptedToken(key: string, value: string) {
  const encrypted = CryptoJS.AES.encrypt(value, SECRET_KEY).toString();
  sessionStorage.setItem(key, encrypted);
}

export function getDecryptedToken(key: string): string | null {
  const encrypted = sessionStorage.getItem(key);
  if (!encrypted) return null;
  try {
    const bytes = CryptoJS.AES.decrypt(encrypted, SECRET_KEY);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch {
    return null;
  }
}

export function clearToken(key: string) {
  sessionStorage.removeItem(key);
}